export default __webpack_public_path__ + "static/media/voucher.30ec3316.svg";